import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
@Injectable({ providedIn: 'root' })
export class MyOskJoinInvitationService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskJoinInvitation`;
  }
  delete(guid: string): Observable<boolean> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (guid !== undefined && guid !== null) {
      params = params.set('guid', guid.toString());
    }
    return this.http.delete<boolean>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
